import styled from "styled-components";

export const FileUploaderWrapper = styled.div`
    .upload-button{
        cursor: pointer;
        height: 38px;
        color: #fff;
        padding: 0px 25px;
        display: flex;
        align-items: center;
        border-radius: 5px;
        background: linear-gradient(90deg,#55C416 0%,#367910 100%);
        width: fit-content;
        font-size: 14px;
        margin-bottom: 1px;
    }
    .disabled{
        opacity: 0.7;
    }
    .remove-button{
        border: none;
        background: transparent;
        padding: 0 0 0 20px;
        color: #002d4b;
    }
    .max-length-label{
        font-size: 11px;
        color: #000;
        font-family: 'latoregular';
        font-style: italic;
        margin: 0;
        padding: 0;
    }
    .file-item{
        border: 1px solid #0A5587;
        border-radius: 20px;
        padding: 2px 12px;
        margin-top: 10px;
        margin-right: 5px;
        width: fit-content;
        font-size: 12px;
    }
    .file-list{
        display: flex;
        flex-wrap: wrap;
    }
`

